import React, { useEffect, useState } from "react";
import "./HelpSection.scss";
import Button from "../Components/Buttons/Button";
import CategoryCard from "./Card/CategoryCard";
import { getCategoryWiseSubcategory } from "../services/getCategoryWiseSubcategory";

const HelpSection = ({ setIsModelOpen, setTypeData }) => {
  const [pageData, setPageData] = useState([]);

  const fetchData = async () => {
    await getCategoryWiseSubcategory("65524e5e3c005ef3b51907c6")
      .then((data) => {
        setPageData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!pageData?.subCategory?.length) {
    return null;
  }

  return (
    <div className="container">
      <div className="background-shadow helpsection">
        <div className="container">
          <div className="title">Homework Help</div>
          <div className="description">
           Instant support for homework across all subjects.
          </div>
          <div className="card-wrapper">
            <div className="row justify-content-center">
              {pageData?.subCategory?.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-6 col-md-4 col-lg-4 d-flex justify-content-center mb-4"
                >
                  <CategoryCard details={item} />
                </div>
              ))}
            </div>
          </div>

          <Button
            text="Get Homework Help"
            varient="primary"
            onClick={() => {
              setTypeData({
                serviceType: "HomeworkHelp",
                type: "mcqHelp",
                totalSteps: 1,
              });
              setIsModelOpen(true);
            }}
          ></Button>
        </div>
      </div>
    </div>
  );
};

export default HelpSection;
